import { render, staticRenderFns } from "./WarningsScore.vue?vue&type=template&id=e5e2837e&"
import script from "./WarningsScore.vue?vue&type=script&lang=js&"
export * from "./WarningsScore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports